export default "__VITE_ASSET__A5xgcP7n__"